import { get } from 'lodash';

import { subjectTypes } from 'z-js-commons';

export function getEditorialHomeworkSubject(subjects) {
    if (!subjects || subjects.length < 1) {
        return '';
    } else {
        return subjectTypes.subjectsMap(get(subjects[0], 'id', 0));
    }
}
